
import { connect } from 'react-redux';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const centerText = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}

const div1 = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "inherit",
  padding: "3px"
}

const div2 = {
  width: "80%",
  height: "80%",
  background: "#fff",
  boxShadow: "15px 15px 25px #ccc",
  borderRadius: "15px"
}
class introEngTest extends Component {
  constructor(props) {
    super(props)
    this.state = {
      accessed: false
    }
  }

  async componentDidMount() {
    await axios.post(`/api/engApi/checkIfTestIsAccessedPre/`)
      .then(resp => {
        if (resp.data.message === true) {
          this.setState({ accessed: true })
        }
      })
      .catch(err => {

      })
  }

  render() {
    const accessButton = this.state.accessed === true ?
      (<Link disabled className="btn btn-danger btn-fill col-md-2" >Pređi na test</Link>) :
      (<Link to="/engTest" className="btn btn-info btn-fill col-md-2" >Pređi na test</Link>)
    return (
      <div className="Content">
        <div style={div1}>
          <div style={div2}>
            <div style={{ textAlign: "center", margin: "24px 50px 12px" }}>
              <div style={{ padding: "16px 0", textAlign: "left" }}>
                <br /><br />
                Zdravo {this.props.auth.user.name},
                <br />
                <br />
                Pred Vama je test engleskog jezika. Ovom testu možete pristupiti samo jednom.
                <br />
                <br />
                Ukoliko se iz nekih nepredviđenih razloga (zatvaranje stranice, izlazak iz pretraživača, osvežavanje stranice testa) izlogujete sa testa, javite se Tanji Petrović na e-mail adresu: tanja.petrovic@galeb.com.
                <br />
                <br />
                Test je vremenski ograničen na 40 minuta i sastoji se iz 4 vežbe.
                <br />
                <br />
                U prvoj vežbi na predviđeno mesto potrebno je da upišete glagol u odgovarajućem vremenu.
                <br />
                U drugoj vežbi potrebno je da reči sa leve strane spojite sa rečima sa desne strane i upišete ih u odgovarajuću rečenicu.
                <br />
                U trećoj vežbi potrebno je da prevedete 6 rečenica sa srpskog na engleski jezik.
                <br />
                Poslednja vežba odnosi se na pisanje poslovnog mejla na zadatu temu.
                <br /><br />
                Srećno
                <br /><br />
                <div style={centerText}>{accessButton}</div>
              </div>
            </div>
          </div>
        </div>
      </div >
    )
  }
}

const mapStateToProps = state => ({
  auth: state.auth,
});

export default connect(
  mapStateToProps,
)(introEngTest);